import * as React from 'react';
import {
  INLINE_COPY_HOST_CLASS,
  InlineCopyBoundary,
} from '@/hen-ui/lib/inline-copy';
import { cn } from '@/hen-ui/utils';
import { browVariants, type BrowVariantProps } from './brow.variants';

export interface BrowProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'>,
    BrowVariantProps {
  children: React.ReactNode;
}

export const Brow = React.forwardRef<HTMLElement, BrowProps>(
  ({ className, color, align, children, ...props }, ref) => {
    return (
      <InlineCopyBoundary>
        <span
          ref={ref}
          className={cn(
            INLINE_COPY_HOST_CLASS,
            browVariants({ color, align }),
            className,
          )}
          {...props}
        >
          {children}
        </span>
      </InlineCopyBoundary>
    );
  },
);

Brow.displayName = 'Brow';
